<template>
    <div>
        <img :src="getPixelUrl">
    </div>
</template>

<script>
    export default {
        name: "pixel",
        computed:{
            getPixelUrl(){

                return this.Helper.getPixelUrl(this);
            }
        },
    }
</script>

<style scoped>

</style>